

(function($) { "use strict";
    // section-shop-archive
    if( $('.section-shop-archive').length ) {


        //manual ajax load-more
        $('.section-shop-archive').on('click', 'a.load-more', function(e){
            //block the click action
            e.preventDefault();
            //remove the load-more button
            $(this).remove();
            //ajax get events
            $.ajax(
                $(this).attr('href'),
                {
                    success: function(data) {
                        //find all events in response and append them to the results
                        $('.sf_results_row > *', data).appendTo($('.sf_results_row'));

                        //copy over the new load-more link, if it exists
                        $('.sf_results_pagination', data).appendTo($('.sf_results'));
                    },
                }
            )
        });

        //
        // // @see https://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery#20420424
        // function setUrlParam(url, paramName, paramValue)
        // {
        //     if (paramValue == null) {
        //         paramValue = '';
        //     }
        //     var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
        //     if (url.search(pattern)>=0) {
        //         return url.replace(pattern,'$1' + paramValue + '$2');
        //     }
        //     url = url.replace(/[?#]$/,'');
        //     return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
        // }


        //onclick of add-to-button disable button
        $('.section-shop-archive button.add-to-basket').on('click', function (e){
            const spektrix_stock_item_id = $(this).closest('spektrix-merchandise').attr('merchandise-item-id');

            //there's two buttons for merchandise that add to the basket. we could disable both on click to prevent re-adding the same item twice
            // if (spektrix_stock_item_id) {
            //     //disable all buttons for the currently clicked item
            //     $('spektrix-merchandise[merchandise-item-id='+spektrix_stock_item_id+']')
            //         .find('button.add-to-basket').attr('disabled','disabled');
            // }

            //hide clicked button
            $(this).hide();

            //show 'Please Wait...'
            $(this).siblings('.loading').show();

        });

        //spektrix events
        $('.section-shop-archive spektrix-merchandise, .section-shop-archive spektrix-gift-vouchers').each(function(){
            $(this).on('success', function(e){
                //hide 'Please Wait...'
                $(this).find('.loading').hide();
                // console.log('event jq success', e)
            });
            $(this).on('fail', function(e){
                //hide 'Please Wait...'
                $(this).find('.loading').hide();

                //re-show the button
                $(this).find('button.add-to-basket').show();
                // console.log('event jq fail', e)
            });
        });




    }
})(jQuery);


